function getToday() {
  const now = new Date();
  const y = now.getFullYear();
  const m = String(now.getMonth() + 1).padStart(2, "0");
  const d = String(now.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}

const bookingUrl = `https://m.booking.naver.com/booking/6/bizes/1503484/items/7082029?area=pll&lang=ko&startDate=${getToday()}&theme=place`;

const mapSrc =
  "https://www.google.com/maps?q=%EA%B4%91%EC%A3%BC%20%EB%8F%99%EA%B5%AC%20%EC%A4%80%EB%B2%95%EB%A1%9C25%EB%B2%88%EA%B8%B8%2016%20%EB%B2%95%EB%AC%B4%EB%B2%95%EC%9D%B8%20%ED%8F%89%EC%9C%A8&output=embed";

export default function Contact() {
  return (
    <section id="contact" className="py-16 md:py-24 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-5">
            <p className="inline-flex items-center gap-2 rounded-full bg-primary-50 px-4 py-1.5 text-xs font-medium text-primary-700 tracking-wide">
              <i className="ri-chat-3-line"></i>
              CONTACT
            </p>
            <h2 className="mt-5 font-heading text-2xl md:text-4xl font-bold text-foreground-950 leading-snug">
              광주부장판사·검사출신변호사와<br />
              <span className="text-accent-600">1:1 맞춤상담</span>을 시작하세요
            </h2>
            <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
              재판의 흐름을 아는 변호사가 여러분의 사건을 정확히 진단하고
              가장 유리한 전략을 제안합니다. 부장판사·검사로 쌓은 경륜을
              의뢰인을 위한 변호로 이어갑니다.
            </p>

            <div className="mt-8 space-y-4">
              <a
                href="tel:062-227-9990"
                className="flex items-center gap-4 rounded-lg bg-white border border-background-200 p-4 hover:border-accent-300 transition-colors"
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-accent-500 text-white shrink-0">
                  <i className="ri-phone-line text-xl"></i>
                </span>
                <div className="flex-1">
                  <p className="text-xs text-foreground-500">법무법인 상담 전화</p>
                  <p className="text-lg font-bold text-foreground-950">062-227-9990</p>
                </div>
              </a>
              <a
                href="tel:062-227-9960"
                className="flex items-center gap-4 rounded-lg bg-white border border-background-200 p-4 hover:border-accent-300 transition-colors"
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-accent-500 text-white shrink-0">
                  <i className="ri-safe-2-line text-xl"></i>
                </span>
                <div className="flex-1">
                  <p className="text-xs text-foreground-500">회생·파산센터 전화</p>
                  <p className="text-lg font-bold text-foreground-950">062-227-9960</p>
                </div>
              </a>
              <a
                href={bookingUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="group flex items-center gap-4 rounded-lg bg-white border border-background-200 p-4 hover:border-accent-300 transition-colors"
              >
                <span className="flex items-center justify-center w-12 h-12 rounded-md bg-accent-500 text-white shrink-0">
                  <i className="ri-calendar-check-line text-xl"></i>
                </span>
                <div className="flex-1">
                  <p className="text-xs text-foreground-500">온라인 예약</p>
                  <p className="text-base font-bold text-foreground-950">네이버 상담 예약</p>
                </div>
              </a>
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="flex flex-col overflow-hidden rounded-lg border border-background-200 bg-white lg:h-full">
              <div className="p-6 pb-0 md:px-8 md:pt-6">
                <div className="flex items-start gap-3">
                  <span className="flex items-center justify-center w-11 h-11 rounded-md bg-accent-500 text-white shrink-0">
                    <i className="ri-road-map-line text-xl"></i>
                  </span>
                  <div>
                    <p className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">
                      오시는 길
                    </p>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed md:text-base">
                      광주 동구 준법로25번길 16, 법무법인 평율 (지산동 707-38)
                    </p>
                    <p className="mt-1.5 text-sm text-foreground-600 leading-relaxed md:text-base hidden md:block">
                      2층 법무법인 평율 / 3층 회생파산센터
                    </p>
                  </div>
                </div>
              </div>
              <div className="min-h-0 flex-1 p-6 pt-3 md:px-8 md:pt-3 md:pb-5">
                <iframe
                  src={mapSrc}
                  title="법무법인 평율 사무소 지도"
                  className="w-full h-[240px] rounded-md border-0 md:h-[380px] lg:h-full lg:min-h-[300px]"
                  loading="lazy"
                  allowFullScreen
                  referrerPolicy="no-referrer-when-downgrade"
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}